import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_43: FaireProductEntity = {
  token: "legacy_prod_abbott-43",
  type: "product",
  name: 'Medium Flower Bloom Bowl Green 5" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/208a26ecdf1191956b6dbe6c7e55601500c298c54f4eed4c146e66780898e52c.jpeg",
  priceDollars: 24,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
